import moment from 'moment-timezone';
import format from 'string-format';
export default {
    sleep: function (millis) {
        return new Promise((resolve) => setTimeout(resolve, millis));
    },

    cnfRegion: function () {
        const localtz = moment.tz.guess();
        return localtz ? localtz : 'Asia/Ho_Chi_Minh';
    },

    toLocal: function (value) {
        // return value.local();
        let zone = this.cnfRegion();
        return value.tz(zone);
    },
    new: function (obj) {
        // return moment(obj).local();
        let zone = this.cnfRegion();
        return moment.tz(obj, zone);
    },
    newUnix: function (obj) {
        return this.new(obj).unix();
    },
    now: function () {
        // return moment().local();
        let zone = this.cnfRegion();
        return moment().tz(zone);
    },
    nowUnix: function () {
        return this.now().unix();
    },
    unix: function (value) {
        if (!value) return null;

        if (typeof value.getMonth === 'function') return this.newUnix(value);
        else if (typeof value === 'number') return value;
        else if (typeof value === 'string') return this.newUnix(value);
        return null;
    },

    newDateAndTime: function (dateUnix, timeUnix) {
        var objDate = this.init(dateUnix);
        var objTime = this.init(timeUnix ? timeUnix : dateUnix);

        return this.new({
            years: objDate.year(),
            months: objDate.month(),
            days: objDate.date(),
            hours: objTime.hour(),
            minutes: objTime.minute()
        });
    },
    timeUnix: function (unixValue) {
        var obj = this.fromUnix(unixValue);
        var newDate = this.new({
            year: 1970,
            month: 0,
            day: 2,
            hour: obj.hour(),
            minute: obj.minute()
        });
        return newDate.unix();
    },
    timeUnixFromMinutes: function (minutes) {
        var newDate = this.new({
            year: 1970,
            month: 0,
            day: 2,
            hour: Math.floor(minutes / 60),
            minute: minutes - Math.floor(minutes / 60) * 60
        });
        return newDate.unix();
    },
    nowTimeUnix: function () {
        return this.timeUnix(this.nowUnix());
    },
    newTimeUnix: function (hour) {
        var newDate = this.new({
            year: 1970,
            month: 0,
            day: 2,
            hour: hour,
            minute: 0
        });
        return newDate.unix();
    },
    convertToUnix(obj, fields) {
        var that = this;
        if (obj && typeof obj === 'object' && fields instanceof Array)
            Object.keys(obj)
                .filter((k) => fields.includes(k))
                .forEach((k) => {
                    if (typeof obj[k] === 'string') {
                        var value = Date.parse(obj[k]);
                        if (value && !isNaN(value)) obj[k] = that.fromDateToUnix(value);
                    }
                });
        else if (typeof obj === 'string') {
            var value = Date.parse(obj);
            if (value && !isNaN(value)) return that.fromDateToUnix(value);
        }
        return obj;
    },
    init: function (value) {
        if (value === null || value === undefined) return null;

        if (moment.isMoment(value)) return this.toLocal(value);

        if (typeof value.getMonth === 'function') return this.new(value);
        else if (typeof value === 'number') return this.toLocal(moment.utc(1000 * value));
        else if (typeof value === 'string') return this.fromString(value);
        return null;
    },
    fromDate: function (dateValue) {
        return this.new(dateValue);
    },
    fromDateToUnix: function (dateValue) {
        return this.new(dateValue).unix();
    },
    fromUnix: function (unixValue, timezone) {
        if (timezone) return moment.utc(1000 * unixValue).tz(timezone);
        return this.toLocal(moment.utc(1000 * unixValue));
    },
    fromString: function (strValue, timezone) {
        // return moment(strValue).local();
        let zone = timezone ? timezone : this.cnfRegion();
        return moment.tz(strValue, zone);
    },
    fromMonthID: function (monthId, timezone) {
        var year = Math.floor(parseInt(monthId) / 100);
        var month = parseInt(monthId) - year * 100;

        var endOfMonth = this.fromString(format('{0}-{1}-01 00:01', year, String(month).padStart(2, '0')), timezone).endOf('month');
        return endOfMonth;
    },
    monthID: function (value) {
        if (!value) return null;

        let date;
        if (typeof value.getMonth === 'function') date = this.new(value);
        else {
            let year = Math.floor(parseInt(value) / 100);
            let month = parseInt(value) - year * 100;
            if (year > 1900 && year < 2100 && month >= 1 && month <= 12) date = this.fromMonthID(value);
            else if (typeof value === 'number') date = this.toLocal(moment.utc(1000 * value));
            else if (typeof value === 'string') date = this.fromString(value);
        }
        if (date) {
            date = date.startOf('month');
            return date.year() * 100 + date.month() + 1;
        }
        return null;
    },
    nextMonthID: function (value, months) {
        if (!value) return null;

        let date;
        if (typeof value.getMonth === 'function') date = this.new(value);
        else {
            let year = Math.floor(parseInt(value) / 100);
            let month = parseInt(value) - year * 100;
            if (year > 1900 && year < 2100 && month >= 1 && month <= 12) date = this.fromMonthID(value);
            else if (typeof value === 'number') date = this.toLocal(moment.utc(1000 * value));
            else if (typeof value === 'string') date = this.fromString(value);
        }
        if (date) {
            date = date.startOf('month').add(months, 'month');
            return date.year() * 100 + date.month() + 1;
        }
        return null;
    },
    monthIDFromDate: function (dateValue) {
        var date = this.new(dateValue).startOf('month');

        return date.year() * 100 + date.month() + 1;
    },

    isValidLicenseTime: function () {
        return true;
        var limitYear = 2025;
        var limitMonth = 9;
        var limitValue = limitYear * 100 + (limitMonth + 1);
        var currentValue = this.nowMonthID();

        return currentValue < limitValue;
    },

    nowMonthID: function () {
        var date = this.now().startOf('month');

        return date.year() * 100 + date.month() + 1;
    },
    year: function (unixValue) {
        var date = this.toLocal(moment.utc(1000 * unixValue)).startOf('year');

        return date.year();
    },
    nowYear: function () {
        var date = this.now().startOf('year');

        return date.year();
    },
    nextMinutes: function (minutes, startAtUnix) {
        return this.init(startAtUnix).add(minutes, 'minutes');
    },
    nextMinutesFromNow: function (minutes) {
        return this.now().add(minutes, 'minutes');
    },
    nextHours: function (hours, startAtUnix) {
        return this.init(startAtUnix).add(hours, 'hours');
    },
    nextHoursFromNow: function (hours) {
        return this.now().add(hours, 'hours');
    },
    nextDays: function (value, days) {
        return this.fromUnix(value.unix()).add(days, 'day');
    },
    nextDaysFromNow: function (days) {
        return this.now().add(days, 'day');
    },
    nextMonthsFromNow: function (months) {
        return this.now().add(months, 'month');
    },
    endOfNextMonthsFromMonthID: function (monthId, months) {
        var year = Math.floor(parseInt(monthId) / 100);
        var month = parseInt(monthId) - year * 100;

        var endOfMonth = this.fromString(format('{0}-{1}-01 00:01', year, String(month).padStart(2, '0')))
            .endOf('month')
            .add(months, 'month');
        return endOfMonth;
    },
    nextMonths: function (value, months) {
        return this.fromUnix(value.unix()).add(months, 'month');
    },
    nextYearsFromNow: function (years) {
        return this.now().add(years, 'year');
    },
    nextYears: function (value, years) {
        return this.fromUnix(value.unix()).add(years, 'year');
    },

    getIsoWeekday: function (dateValue) {
        return this.init(dateValue).isoWeekday();
    },

    isUnixWithinYesterday: function (unixValue) {
        var v1 = this.nextDaysFromNow(-1).startOf('day').unix();
        var v2 = this.nextDaysFromNow(-1).endOf('day').unix();
        return v1 <= unixValue && unixValue <= v2;
    },
    isUnixWithinTomorrow: function (unixValue) {
        var v1 = this.nextDaysFromNow(1).startOf('day').unix();
        var v2 = this.nextDaysFromNow(1).endOf('day').unix();
        return v1 <= unixValue && unixValue <= v2;
    },
    isUnixWithinToDay: function (unixValue) {
        var v1 = this.startOfCurrentDay().unix();
        var v2 = this.endOfCurrentDay().unix();
        return v1 <= unixValue && unixValue <= v2;
    },

    isUnixWithinMinutes: function (unixValue, minutes) {
        var v1 = this.nextMinutesFromNow(-minutes).unix();
        var v2 = this.nextMinutesFromNow(minutes).unix();
        return v1 <= unixValue && unixValue <= v2;
    },

    isUnixWithinCurrentYear: function (unixValue) {
        var v1 = this.fromUnix(unixValue).format('YYYY');
        var v2 = this.now().format('YYYY');
        return v1 === v2;
    },
    isDateWithinYesterday: function (dateValue) {
        let unixValue = this.init(dateValue).unix();
        var v1 = this.nextDaysFromNow(-1).startOf('day').unix();
        var v2 = this.nextDaysFromNow(-1).endOf('day').unix();
        return v1 <= unixValue && unixValue <= v2;
    },
    isDateWithinTomorrow: function (dateValue) {
        let unixValue = this.init(dateValue).unix();
        var v1 = this.nextDaysFromNow(1).startOf('day').unix();
        var v2 = this.nextDaysFromNow(1).endOf('day').unix();
        return v1 <= unixValue && unixValue <= v2;
    },
    isDateWithinCurrentYear: function (dateValue) {
        let unixValue = this.init(dateValue).unix();
        var v1 = this.fromUnix(unixValue).format('YYYY');
        var v2 = this.now().format('YYYY');
        return v1 === v2;
    },
    isDateWithinToDay: function (dateValue) {
        let unixValue = this.init(dateValue).unix();
        var v1 = this.startOfCurrentDay().unix();
        var v2 = this.endOfCurrentDay().unix();
        return v1 <= unixValue && unixValue <= v2;
    },
    startOfDay: function (dateValue) {
        return this.new(dateValue).startOf('day');
    },
    startOfToday: function () {
        return this.now().startOf('day');
    },
    startOfNextDay: function (days) {
        return this.nextDaysFromNow(days !== undefined ? parseFloat(days) : 1).startOf('day');
    },
    startOfNextMonday: function () {
        const dayIndex = 1; // for Monday
        const today = this.now().isoWeekday();

        if (today <= dayIndex) {
            return this.now().isoWeekday(dayIndex).startOf('day');
        } else {
            return this.now().add(1, 'weeks').isoWeekday(dayIndex).startOf('day');
        }
    },
    startOfNextSaturday: function () {
        const dayIndex = 6; // for Saturday
        const today = this.now().isoWeekday();

        if (today <= dayIndex) {
            return this.now().isoWeekday(dayIndex).startOf('day');
        } else {
            return this.now().add(1, 'weeks').isoWeekday(dayIndex).startOf('day');
        }
    },
    startOfNextSunday: function () {
        return this.now().isoWeekday(7).startOf('day');
    },
    startOfMonth: function (dateValue) {
        return this.new(dateValue).startOf('month');
    },
    startOfYear: function (dateValue) {
        return this.new(dateValue).startOf('year');
    },
    startOfDayFromUnix: function (unixValue) {
        return this.fromUnix(unixValue).startOf('day');
    },
    startOfMonthFromUnix: function (unixValue) {
        return this.fromUnix(unixValue).startOf('month');
    },
    startOfYearFromUnix: function (unixValue) {
        return this.fromUnix(unixValue).startOf('year');
    },

    startOfCurrentDay: function () {
        return this.now().startOf('day');
    },
    startOfCurrentMonth: function () {
        return this.now().startOf('month');
    },
    startOfNextMonth: function (months) {
        return this.nextMonthsFromNow(months !== undefined ? parseFloat(months) : 1).startOf('month');
    },
    startOfCurrentYear: function () {
        return this.now().startOf('year');
    },
    endOfToday: function () {
        return this.now().endOf('day');
    },
    endOfNextDay: function (days) {
        return this.nextDaysFromNow(days !== undefined ? parseFloat(days) : 1).endOf('day');
    },
    endOfNextMonday: function () {
        const dayIndex = 1; // for Monday
        const today = this.now().isoWeekday();

        if (today <= dayIndex) {
            return this.now().isoWeekday(dayIndex).endOf('day');
        } else {
            return this.now().add(1, 'weeks').isoWeekday(dayIndex).endOf('day');
        }
    },
    endOfNextSaturday: function () {
        const dayIndex = 6; // for Saturday
        const today = this.now().isoWeekday();

        if (today <= dayIndex) {
            return this.now().isoWeekday(dayIndex).endOf('day');
        } else {
            return this.now().add(1, 'weeks').isoWeekday(dayIndex).endOf('day');
        }
    },
    endOfNextSunday: function () {
        return this.now().isoWeekday(7).endOf('day');
    },
    endOfDay: function (dateValue) {
        return this.new(dateValue).endOf('day');
    },
    endOfMonth: function (dateValue) {
        return this.new(dateValue).endOf('month');
    },
    endOfYear: function (dateValue) {
        return this.new(dateValue).endOf('year');
    },
    endOfDayFromUnix: function (unixValue) {
        return this.fromUnix(unixValue).endOf('day');
    },
    endOfMonthFromUnix: function (unixValue) {
        return this.fromUnix(unixValue).endOf('month');
    },
    endOfYearFromUnix: function (unixValue) {
        return this.fromUnix(unixValue).endOf('year');
    },

    endOfCurrentDay: function () {
        return this.now().endOf('day');
    },
    endOfCurrentMonth: function () {
        return this.now().endOf('month');
    },
    endOfNextMonth: function (months) {
        return this.nextMonthsFromNow(months !== undefined ? parseFloat(months) : 1).endOf('month');
    },
    endOfCurrentYear: function () {
        return this.now().endOf('year');
    },
    isWithinHours(minHour, maxHour) {
        var cHour = this.now().hour();

        if (!minHour) return cHour < maxHour;
        if (!maxHour) return cHour >= minHour;

        if (minHour < maxHour) return minHour <= cHour && cHour < maxHour;
        else if (minHour === maxHour) return minHour === cHour;

        return false;
    },
    diffSeconds(unixStart, unixEnd, allowNegative) {
        var vStart = this.fromUnix(unixStart);
        var vEnd = this.fromUnix(unixEnd);
        if (!allowNegative && !vStart.isBefore(vEnd)) return 0;
        if (allowNegative && !vStart.isBefore(vEnd)) return -vStart.diff(vEnd, 'seconds', true);
        return vEnd.diff(vStart, 'seconds', true);
    },
    diffMinutes(unixStart, unixEnd, allowNegative) {
        var vStart = this.fromUnix(unixStart);
        var vEnd = this.fromUnix(unixEnd);
        if (!allowNegative && !vStart.isBefore(vEnd)) return 0;
        if (allowNegative && !vStart.isBefore(vEnd)) return -vStart.diff(vEnd, 'minutes', true);
        return vEnd.diff(vStart, 'minutes', true);
    },
    diffHours(unixStart, unixEnd, allowNegative) {
        var vStart = this.fromUnix(unixStart);
        var vEnd = this.fromUnix(unixEnd);
        if (!allowNegative && !vStart.isBefore(vEnd)) return 0;
        if (allowNegative && !vStart.isBefore(vEnd)) return -vStart.diff(vEnd, 'hours', true);
        return vEnd.diff(vStart, 'hours', true);
    },
    diffDays(unixStart, unixEnd, allowNegative) {
        var vStart = this.fromUnix(unixStart);
        var vEnd = this.fromUnix(unixEnd);
        if (!allowNegative && !vStart.isBefore(vEnd)) return 0;
        if (allowNegative && !vStart.isBefore(vEnd)) return -vStart.diff(vEnd, 'days', true);
        return vEnd.diff(vStart, 'days', true);
    },
    diffWeeks(unixStart, unixEnd, allowNegative) {
        var vStart = this.fromUnix(unixStart);
        var vEnd = this.fromUnix(unixEnd);
        if (!allowNegative && !vStart.isBefore(vEnd)) return 0;
        if (allowNegative && !vStart.isBefore(vEnd)) return -vStart.diff(vEnd, 'weeks', true);
        return vEnd.diff(vStart, 'weeks', true);
    },
    diffMonths(unixStart, unixEnd, allowNegative) {
        var vStart = this.fromUnix(unixStart);
        var vEnd = this.fromUnix(unixEnd);
        if (!allowNegative && !vStart.isBefore(vEnd)) return 0;
        if (allowNegative && !vStart.isBefore(vEnd)) return -vStart.diff(vEnd, 'months', true);
        return vEnd.diff(vStart, 'months', true);
    },
    diffYears(unixStart, unixEnd, allowNegative) {
        var vStart = this.fromUnix(unixStart);
        var vEnd = this.fromUnix(unixEnd);
        if (!allowNegative && !vStart.isBefore(vEnd)) return 0;
        if (allowNegative && !vStart.isBefore(vEnd)) return -vStart.diff(vEnd, 'years', true);
        return vEnd.diff(vStart, 'years', true);
    },
    diffSecondToNow(unixStart, allowNegative) {
        return this.diffSeconds(unixStart, this.nowUnix(), allowNegative);
    },
    diffMinuteToNow(unixStart, allowNegative) {
        return this.diffMinutes(unixStart, this.nowUnix(), allowNegative);
    },
    diffHourToNow(unixStart, allowNegative) {
        return this.diffHours(unixStart, this.nowUnix(), allowNegative);
    },
    diffDayToNow(unixStart, allowNegative) {
        return this.diffDays(unixStart, this.nowUnix(), allowNegative);
    },
    diffWeekToNow(unixStart, allowNegative) {
        return this.diffWeeks(unixStart, this.nowUnix(), allowNegative);
    },
    diffMonthToNow(unixStart, allowNegative) {
        return this.diffMonths(unixStart, this.nowUnix(), allowNegative);
    },
    diffYearToNow(unixStart, allowNegative) {
        return this.diffYears(unixStart, this.nowUnix(), allowNegative);
    }
};
